import { useEffect, useState } from 'react';
import Api from '../api/Api';
import { Theme } from '../constants/theme';

export default function useMemberCollection(userId) {
    const [isMember, setIsMember] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;

        const fetchMemberCollection = async () => {
            try {
                setLoading(true);
                setError(null);

                const user = await Api.User.getOne(userId);
                const themeCollection =
                    document.documentElement.getAttribute('data-theme') === Theme.COLLECTION;

                if (!cancelled && user && themeCollection) {
                    const member = Boolean(user?.is_he_collection);
                    setIsMember(member);
                }
            } catch (e) {
                if (!cancelled) {
                    console.error('error fetch member collection', e);
                    setError(e);
                    setIsMember(false);
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        };

        if (userId) {
            fetchMemberCollection();
        }

        return () => {
            cancelled = true;
        };
    }, [userId]);

    return { isMember, isLoading, error };
}
